import useComplianceView from "./useComplianceView";
import useEventDetailsGrid from "./useEventDetailsGrid";

export default function useCustomerButton() {
  const { setViewData } = useComplianceView();
  const { onRefresh } = useEventDetailsGrid();

  const searchForCustomer = (event, name) => {
    event.preventDefault();
    event.stopPropagation();

    setViewData({ allNames: name, eventsGridLoading: true });

    onRefresh(false, true, name, true);
  };

  return { searchForCustomer };
}
